import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':country/:language',
    children: [
      {
        path: 'mac-address',
        loadChildren: () => import('./features/mac-address/mac-address.module').then((m) => m.MacAddressModule),
      },
      {
        path: '**',
        redirectTo: 'mac-address',
        pathMatch: 'full',
      },
    ],
  },
  // when a path is not found, redirect to "mac-addtess"

  {
    path: '**',
    loadChildren: () => import('./features/mac-address/mac-address.module').then((m) => m.MacAddressModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }